module.exports = __webpack_public_path__ + "puppet-812b4799b10ae32ef009254a1b17f1d9.svg";